import { type FC, type PropsWithChildren } from 'react';

import { Container } from '@eneco/custom-components/flows/PriceDetails';

import { Content, Footer } from './PriceDetails.Content';
import { CostSummaryGrid } from './PriceDetails.CostSummaryGrid';
import { TariffCalculationRow, TariffExpandableRow } from './PriceDetails.TariffRows';
import { Title } from './PriceDetails.Title';

export { typeTheme } from './PriceDetails.theme';
export type { CostSummaryGridRow, Details, TariffCalculationSection } from './PriceDetails.types';

interface PriceDetailsProps {
  className?: string;
}

interface CompoundPriceDetailsProps {
  Title: typeof Title;
  Content: typeof Content;
  Footer: typeof Footer;
  CostSummaryGrid: typeof CostSummaryGrid;
  TariffCalculationRow: typeof TariffCalculationRow;
  TariffExpandableRow: typeof TariffExpandableRow;
}

export const PriceDetails: FC<PropsWithChildren<PriceDetailsProps>> & CompoundPriceDetailsProps = ({
  children,
  className,
}) => (
  <Container borderRadius="m" backgroundColor="backgroundPrimary" overflow="hidden" className={className}>
    {children}
  </Container>
);

PriceDetails.Title = Title;
PriceDetails.Content = Content;
PriceDetails.Footer = Footer;
PriceDetails.CostSummaryGrid = CostSummaryGrid;
PriceDetails.TariffCalculationRow = TariffCalculationRow;
PriceDetails.TariffExpandableRow = TariffExpandableRow;
